import React from 'react'
import { FaFacebookF, FaInstagram, FaMapMarkerAlt, } from 'react-icons/fa'
import { IoMdMail } from 'react-icons/io'
import { AiFillMobile } from "react-icons/ai";
import { GiPlainSquare } from 'react-icons/gi';
import logo from '../../Assets/Green.png'
import { FaXTwitter } from "react-icons/fa6";
import { FaPinterest } from "react-icons/fa";

const Footer = () => {
  return (
    <div className="bg-[#1E2023]">
      <div className="max-w-screen-xl mx-auto p-4">
        <div className="h-[260px] border border-gray-300 mt-5 overflow-hidden">
          <iframe
            title="Google Map Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1944.2204201081345!2d79.13326711538038!3d12.94361880236128!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bad389e52d9e0f1%3A0x36d8150e6f5a203a!2sGreen%20Arcade!5e0!3m2!1sen!2sin!4v1738740873515!5m2!1sen!2sin"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>

        <div className="mt-5 flex flex-col space-y-3 md:space-y-0 md:flex-row justify-between">
          <span className="flex gap-4 ">
            <FaMapMarkerAlt
              className="bg-[#068b07] text-white px-1 py-2 "
              size={40}
            />
            <span>
              <h3 className="text-gray-200 text-sm">LOCATION</h3>
              <p className="text-white font-medium text-xs">
                2nd Floor, Najam Centre, Virudampet, <br />
                Vellore - 632006, Tamil Nadu, India
              </p>
            </span>
          </span>
          <span className="flex gap-4 ">
            <IoMdMail className="bg-[#068b07] text-white px-1 py-2" size={40} />
            <span>
              <h3 className="text-gray-200 text-sm">SEND EMAIL US</h3>
              <p className="text-white font-medium underline text-sm">
                greenarcade.official@gmail.com
              </p>
            </span>
          </span>
          <span className="flex gap-4 ">
            <AiFillMobile
              className="bg-[#068b07] text-white px-1 py-2"
              size={40}
            />
            <span>
              <h3 className="text-gray-200 text-sm">CALL US 24/7</h3>
              <p className="text-white font-medium text-sm">+91 9791692008</p>
            </span>
          </span>
        </div>
      </div>

      <span className="flex mx-auto justify-center max-w-screen-2xl space-x-2">
        <GiPlainSquare className="text-[#068b07]" size={12} />
        <div className="w-5/6 mt-1.5 h-[1px] bg-gray-300"></div>{" "}
        {/* Centered Line */}
        <GiPlainSquare className="text-[#068b07]" size={12} />
      </span>

      <div className="max-w-screen-xl mx-auto flex flex-col md:flex-row justify-between mt-1">
        <div className="flex flex-col md:flex-col justify-center items-center">
          <img src={logo} alt="logo" className="h-24" />
          {/* <p className='text-gray-200  text-centertext-sm  mt-2 '>
            GROUP OF GREEN INDIA CITY DEVELOPER
          </p> */}
        </div>

        <div className="text-white md:ml-0 ml-8 mt-6 md:mt-0">
          {/* <h1 className="text-xl font-semibold mb-4">Main Menu</h1> */}
          <div className="grid grid-cols-2 gap-4 text-sm mt-6">
            {/* Left Column */}
            <div className="space-y-2">
              <div className="flex items-center space-x-2">
                <GiPlainSquare className="text-[#068b07]" size={10} />
                <a href="/" className="hover:text-gray-300 transition">
                  Home
                </a>
              </div>
              <div className="flex items-center space-x-2">
                <GiPlainSquare className="text-[#068b07]" size={10} />
                <a href="/about" className="hover:text-gray-300 transition">
                  About Us
                </a>
              </div>

              <div className="flex items-center space-x-2">
                <GiPlainSquare className="text-[#068b07]" size={10} />
                <a href="/services" className="hover:text-gray-300 transition">
                  Our Services
                </a>
              </div>
            </div>

            {/* Right Column */}
            <div className="space-y-2">
              {/* <div className='flex items-center space-x-2'>
            <GiPlainSquare className='text-[#068b07]' size={10} />
            <a href="/leadership" className="hover:text-gray-300 transition">Leadership</a>
          </div> */}
              {/* <div className='flex items-center space-x-2'>
            <GiPlainSquare className='text-[#068b07]' size={10} />
            <a href="/contact" className="hover:text-gray-300 transition">Careers</a>
          </div> */}
              <div className="flex items-center space-x-2">
                <GiPlainSquare className="text-[#068b07]" size={10} />
                <a href="/our-works" className="hover:text-gray-300 transition">
                  Our Projects
                </a>
              </div>
              <div className="flex items-center space-x-2">
                <GiPlainSquare className="text-[#068b07]" size={10} />
                <a href="/about" className="hover:text-gray-300 transition">
                  Why Choose Us
                </a>
              </div>
              <div className="flex items-center space-x-2">
                <GiPlainSquare className="text-[#068b07]" size={10} />
                <a href="/contact" className="hover:text-gray-300 transition">
                  Contact Us
                </a>
              </div>
              {/* <div className='flex items-center space-x-2'>
            <GiPlainSquare className='text-[#068b07]' size={10} />
            <a href="/news" className="hover:text-gray-300 transition">Latest News</a>
          </div> */}
            </div>
          </div>
        </div>

        <div className="my-6">
          <div className="flex justify-center gap-8 p-1 text-gray-500">
            <a
              href="https://www.facebook.com/greenarcadein/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebookF
                size={32}
                className="hover:text-[#068b07] bg-[#2e3033] p-1 border-gray-400 cursor-pointer"
              />
            </a>
            <a
              href="https://www.instagram.com/green_arcade_official/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram
                size={32}
                className="hover:text-[#068b07] bg-[#2e3033] p-1 cursor-pointer"
              />
            </a>
            <a
              href="https://x.com/greenarcade_off"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaXTwitter
                size={32}
                className="hover:text-[#068b07] bg-[#2e3033] p-1 cursor-pointer"
              />
            </a>
            <a
              href="https://in.pinterest.com/greenarcadeofficial/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaPinterest
                size={32}
                className="hover:text-[#068b07] bg-[#2e3033] p-1 cursor-pointer"
              />
            </a>
          </div>
          <p className="text-sm flex justify-center text-center font-medium pt-2 text-gray-200">
            Building dreams, one brick at a time. <br />
            Follow us for updates on our latest projects!
          </p>
        </div>
      </div>

      <span className="flex mx-auto justify-center mt-2 max-w-screen-2xl space-x-2">
        <GiPlainSquare className="text-[#068b07]" size={12} />
        <div className="w-5/6 mt-1.5 h-[1px] bg-gray-300"></div>{" "}
        {/* Centered Line */}
        <GiPlainSquare className="text-[#068b07]" size={12} />
      </span>

      <div className="mt-3 max-w-screen-xl mx-auto p-4 text-center text-gray-500 text-sm">
        <div className="flex flex-col md:flex-row justify-between items-center">
          {/* Left Links */}
          <div className="mb-4 md:mb-0">
            <span>
              &copy; {new Date().getFullYear()}{" "}
              <span className="text-[#068b07] font-medium">GREEN ARCADE</span>{" "}
              BY . ALL RIGHTS RESERVED
            </span>
          </div>

          {/* Right Copy */}
          <p className="text-gray-500 mt-2">
            Designed by{" "}
            <a
              href="https://greenemeraldbranding.com/"
              className="text-[#068b07] font-semibold"
              target="_blank"
              rel="noopener noreferrer"
            >
              Green Emerald
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Footer
